import { render, staticRenderFns } from "./deleteIntegralRule.vue?vue&type=template&id=0db0ca86"
import script from "./deleteIntegralRule.vue?vue&type=script&lang=js"
export * from "./deleteIntegralRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports